<template>
  <div id="data-list-list-view" class="data-list-container">
    <trainee-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" />
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="products">

      <template slot="thead">
        <vs-th sort-key="id">{{ $t("tblHeadings.th1") }}</vs-th>
        <vs-th sort-key="name">{{ $t("tblHeadings.th2") }}</vs-th>
        <vs-th sort-key="onboarding">{{ $t("tblHeadings.th7") }}</vs-th>
        <vs-th sort-key="monitoringFilter">{{ $t("tblHeadings.th8") }}</vs-th>
<!--        <vs-th sort-key="feedbackInviteeCount">{{ $t("tblHeadings.th9") }}</vs-th>-->
        <vs-th sort-key="Feedback11">{{ $t("tblHeadings.th10") }}</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{data}">
        <!--          {{data}}-->
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
<!--         {{tr.coachingSurvey}}-->
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.id }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.userData[0].firstName }} {{ tr.userData[0].lastName }}</p>
          </vs-td>
          <vs-td>
            <feather-icon  v-if="tr.userData[0].isVerified===1" icon="CircleIcon" :title='$t("playerJourney.t1_1")' :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
            <feather-icon v-else icon="CircleIcon"  :title='$t("playerJourney.t1_2")' :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
            <feather-icon v-if="tr.skillCount>=1" class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t2_1")' :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
            <feather-icon  v-else class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t2_2")' :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
<!--            <feather-icon v-if="tr.developmentActionLength>=1" class="ml-2" title="Development Action Added" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />-->
<!--            <feather-icon  v-else class="ml-2" icon="CircleIcon" title="Development Action Not Added" :svgClasses="['fill-current h-4 w-4', 'text-grey']" />-->
<!--            <feather-icon v-if="tr.feedbackInviteeCount>=1" class="ml-2" title="Has requested at least one feedback" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />-->
<!--            <feather-icon  v-else class="ml-2" icon="CircleIcon" title="Has not requested at least one feedback" :svgClasses="['fill-current h-4 w-4', 'text-grey']" />-->
          </vs-td>
          <vs-td>
            <feather-icon v-if="tr.motivationSurvey===1" icon="CircleIcon" :title='$t("playerJourney.t3_1")' :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
            <feather-icon v-else-if="tr.motivationSurvey===2" icon="CircleIcon"  :title='$t("playerJourney.t3_2")' :svgClasses="['fill-current nt h-4 w-4', 'text-warning']" />
            <feather-icon v-else icon="CircleIcon"  :title='$t("playerJourney.t3_3")' :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
            <feather-icon v-if="tr.coachingSurvey===1" class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t4_1")' :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
            <feather-icon v-else-if="tr.coachingSurvey===2" class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t4_2")' :svgClasses="['fill-current h-4 w-4', 'text-warning']" />
            <feather-icon v-else class="ml-2" icon="CircleIcon"  :title='$t("playerJourney.t4_3")' :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
          </vs-td>
<!--          <vs-td>-->
<!--          <feather-icon v-if="tr.feedbackInviteeCount>=1" class="ml-2" title="Last requested Feedback  Received" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />-->
<!--          &lt;!&ndash; <feather-icon  v-else-if="" class="ml-2" icon="CircleIcon" title="Last schedule request Feedback  Received " :svgClasses="['fill-current h-4 w-4', 'text-warning']" /> &ndash;&gt;-->
<!--          <feather-icon  v-else class="ml-2" icon="CircleIcon" title="Feedback not received" :svgClasses="['fill-current h-4 w-4', 'text-grey']" />-->
<!--        </vs-td>-->

          <vs-td class="whitespace-no-wrap">
            <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />-->
            <vs-button @click="editData(tr.userData[0].id)">{{ $t("coach.traineeList.tl5") }}</vs-button>
          </vs-td>
          <vs-td>
            <div class="flex align-center justify-end">
              <trainee-coach-notes v-bind:commuId="tr.userData[0].id" v-bind:key="'note-'+tr.userData[0].id"></trainee-coach-notes>
              <Todo :userId="tr.userData[0].id" v-bind:key="'todo-'+tr.userData[0].id"></Todo>
            </div>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import TraineeViewSidebar from './TraineeViewSidebar.vue'
  import moduleDataList from '@/store/data-list/moduleDataList.js'
  import FeatherIcon from '../../../../components/FeatherIcon.vue'
  import Notes from '@/layouts/components/navbar/components/Notes.vue'
  import Todo from '../../todo/Todo.vue'

  export default {
    components: {
      TraineeViewSidebar,
      FeatherIcon,
      Notes,
      Todo
    },
    data () {
      return {
        selected: [],
        // products: [],
        itemsPerPage: 400,
        isMounted: false,
        skillCount:'',
        skillsName:[],
        data:[],
        length:0,
        count:0,
        // Data Sidebar
        addNewDataSidebar: false,
        // sidebarData: 0
      }
    },



    computed: {
      currentPage () {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
      products () {
        //console.log('all trainee list',this.$store.state.traineeCoachAssignment.traineeList);
        this.data=this.$store.state.traineeCoachAssignment.traineeList;


        console.log('all trainee list', this.data);
        for (let i = 0; i < this.data.length; i++) {
          this.$store.dispatch('addSkill/findCompetency', {query: {usersId: this.data[i].traineeId}})
            .then(res => {
              this.data[i].onboarding=0
              this.data[i].monitoringFilter=0;
              let markGoalCompleteCount = 0;
              let feedbackRequestedCount = 0;
              let developmentActionLength=0;

              console.log('res.data.length',res.data);
              for (let j = 0; j < res.data.length; j++) {
                this.data[i].goalCompleteCount = markGoalCompleteCount
                this.$store.dispatch('endorsement-invite/find', {query: {traineeCompetenciesId: res.data[j].id}})
                  .then(res => {
                    console.log('invitee data',res);
                    if (res.data.length !== 0) {
                      feedbackRequestedCount = developmentActionLength + res.data.length;
                    }
                    this.data[i].feedbackInviteeCount = feedbackRequestedCount
                  })
                  .catch(err => {
                  })
                this.$store.dispatch('development-actions/find', {query: {traineeCompetenciesId: res.data[j].id}})
                  .then(res => {
                    console.log('development-actions data',res);
                    if (res.data.length !== 0) {
                      developmentActionLength = developmentActionLength+res.data.length;
                    }
                    this.data[i].developmentActionLength = developmentActionLength
                  })
                  .catch(err => {
                  })
              }
              console.log('developmentActionLength',developmentActionLength)
              if (res.data[0].coachingSurveyDate !=null && res.data[0].progressStatus==='in_progress'){
                if(new Date() < new  Date(res.data[0].coachingSurveyDate)){
                  console.log('coaching Completed');
                  this.coachingSurveyDate=res.data[0].coachingSurveyDate;
                  this.data[i].coachingSurvey=1;
                }else if(new Date() > new Date(res.data[0].coachingSurveyDate)){
                  console.log('coaching overDue');
                  this.coachingSurveyDate=res.data[0].coachingSurveyDate;
                  const date1 = new Date(this.coachingSurveyDate);
                  const date2 = new Date();
                  const diffTime = Math.abs(date2 - date1);
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                  this.coachingOverdueCounter=diffDays;
                  //console.log(diffTime + " milliseconds");
                  console.log(diffDays + " days");
                  this.data[i].coachingSurvey=2;
                  //this.coachingSurveyStatus=2; //2 for overdue
                }
              }
              if (res.data[0].motivationSurveyDate !=null && res.data[0].progressStatus==='in_progress'){
                if(new Date() < new  Date(res.data[0].motivationSurveyDate)){
                  console.log('Completed');
                  this.motivationSurveyDate=res.data[0].motivationSurveyDate;
                  this.data[i].motivationSurvey=1;
                }else if(new Date() > new Date(res.data[0].motivationSurveyDate)){
                  console.log('overDue');
                  this.motivationSurveyDate=res.data[0].motivationSurveyDate;
                  const date1 = new Date(this.motivationSurveyDate);
                  const date2 = new Date();
                  const diffTime = Math.abs(date2 - date1);
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                  this.coachingOverdueCounter=diffDays;
                  //console.log(diffTime + " milliseconds");
                  console.log(diffDays + " days");
                  this.data[i].motivationSurvey=2;
                  //this.coachingSurveyStatus=2; //2 for overdue
                }
              }
              this.data[i].skillCount = res.data.length
              if(res.data.length===0){
                this.data[i].goalCompleteCount=0
                this.data[i].feedbackInviteeCount=0

              }else{
                for(let i=0;i<=res.data.length;i++){
                  const characteristicId =  res.data[i].competencyId.split("-")[0];
                  const competencyId =  res.data[i].competencyId.split("-")[1];
                  console.log(characteristicId, competencyId);
                  const competencies = this.CCD[characteristicId].competencies;
                  console.log(competencies);
                  const currentCompetency = competencies[competencyId];
                  this.skillsName.push(currentCompetency.comp);
                }
                console.log('all skills name',this.skillsName);
              }
            })
            .catch(err => {
            })
        }
        return this.data;
      },
      queriedItems () {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      },

    },
    methods: {
      // addNewData () {
      //   this.sidebarData = {}
      //   this.toggleDataSidebar(true)
      // },
      // deleteData (id) {
      //   this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
      // },
      editData (id) {
        //this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = id
        this.$store.dispatch("traineeCoachAssignment/setSidebarId", id).then(res => {
          console.log(res);
          this.toggleDataSidebar(true)
        })
      },
      toggleDataSidebar (val = false) {
        if(val === false) {
          this.$store.dispatch("traineeCoachAssignment/setSidebarId", 0).then(res => {})
        }
        this.addNewDataSidebar = val
      }
    },

    created () {
      //  if (!moduleDataList.isRegistered) {
      //   this.$store.registerModule('dataList', moduleDataList)
      //   moduleDataList.isRegistered = true
      // }
      const coachId = this.$store.state.AppActiveUser.usersId
      let query={}
      if(coachId===1){
        query={query: {status:'active'}}
      }
      else {
        query={query: {coachId,status:'active'}}
      }
      console.log('coachId',coachId);
      this.$store.dispatch('traineeCoachAssignment/fetchTrainees',query)
        .then(res => {
          if(res.length > 0) {
            console.log("all trainee data", res.data);
          }
        })
        .catch(err => {})
    },
    mounted () {
      this.isMounted = true
    }
  }
</script>

<style lang="scss">
  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>

<!--<template>-->
<!--  <div id="data-list-list-view" class="data-list-container">-->

<!--    <trainee-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" />-->

<!--    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="products">-->

<!--      <template slot="thead">-->
<!--        <vs-th sort-key="id">{{ $t("coach.traineeList.tl1") }}</vs-th>-->
<!--        <vs-th sort-key="name">{{ $t("coach.traineeList.tl2") }}</vs-th>-->
<!--        <vs-th sort-key="email">{{ $t("coach.traineeList.tl3") }}</vs-th>-->
<!--        <vs-th>{{ $t("coach.traineeList.tl4") }}</vs-th>-->
<!--      </template>-->

<!--      <template slot-scope="{data}">-->
<!--        <tbody>-->
<!--        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->

<!--          <vs-td>-->
<!--            <p class="product-name font-medium truncate">{{ tr.id }}</p>-->
<!--          </vs-td>-->

<!--          <vs-td>-->
<!--            <p class="product-name font-medium truncate">{{ tr.userData[0].firstName }} {{ tr.userData[0].lastName }}</p>-->
<!--          </vs-td>-->

<!--          <vs-td>-->
<!--            <p class="product-name font-medium truncate">{{ tr.userData[0].email }}</p>-->
<!--          </vs-td>-->

<!--          <vs-td class="whitespace-no-wrap">-->
<!--            &lt;!&ndash;<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />&ndash;&gt;-->
<!--            <vs-button @click="editData(tr.userData[0].id)">{{ $t("coach.traineeList.tl5") }}</vs-button>-->
<!--          </vs-td>-->

<!--        </vs-tr>-->
<!--        </tbody>-->
<!--      </template>-->
<!--    </vs-table>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--  import TraineeViewSidebar from './TraineeViewSidebar.vue'-->
<!--  import moduleDataList from '@/store/data-list/moduleDataList.js'-->

<!--  export default {-->
<!--    components: {-->
<!--      TraineeViewSidebar-->
<!--    },-->
<!--    data () {-->
<!--      return {-->
<!--        selected: [],-->
<!--        // products: [],-->
<!--        itemsPerPage: 100,-->
<!--        isMounted: false,-->

<!--        // Data Sidebar-->
<!--        addNewDataSidebar: false,-->
<!--        // sidebarData: 0-->
<!--      }-->
<!--    },-->
<!--    computed: {-->
<!--      currentPage () {-->
<!--        if (this.isMounted) {-->
<!--          return this.$refs.table.currentx-->
<!--        }-->
<!--        return 0-->
<!--      },-->
<!--      products () {-->
<!--        return this.$store.state.traineeCoachAssignment.traineeList-->
<!--      },-->
<!--      queriedItems () {-->
<!--        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length-->
<!--      }-->
<!--    },-->
<!--    methods: {-->
<!--      /*addNewData () {-->
<!--        this.sidebarData = {}-->
<!--        this.toggleDataSidebar(true)-->
<!--      },*/-->
<!--      /*deleteData (id) {-->
<!--        this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })-->
<!--      },*/-->
<!--      editData (id) {-->
<!--        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))-->
<!--        // this.sidebarData = id-->
<!--        this.$store.dispatch("traineeCoachAssignment/setSidebarId", id).then(res => {-->
<!--          this.toggleDataSidebar(true)-->
<!--        })-->
<!--      },-->
<!--      toggleDataSidebar (val = false) {-->
<!--        if(val === false) {-->
<!--          this.$store.dispatch("traineeCoachAssignment/setSidebarId", 0).then(res => {})-->
<!--        }-->
<!--        this.addNewDataSidebar = val-->
<!--      }-->
<!--    },-->
<!--    created () {-->
<!--      if (!moduleDataList.isRegistered) {-->
<!--        this.$store.registerModule('dataList', moduleDataList)-->
<!--        moduleDataList.isRegistered = true-->
<!--      }-->
<!--      const coachId = this.$store.state.AppActiveUser.usersId-->
<!--      this.$store.dispatch('traineeCoachAssignment/fetchTrainees', {query: {coachId}})-->
<!--        .then(res => {-->
<!--          if(res.total > 0) {-->
<!--            console.log("all trainee data", res.data);-->
<!--          }-->
<!--        })-->
<!--        .catch(err => {})-->
<!--    },-->
<!--    mounted () {-->
<!--      this.isMounted = true-->
<!--    }-->
<!--  }-->
<!--</script>-->

<!--<style lang="scss">-->
<!--  #data-list-list-view {-->
<!--    .vs-con-table {-->

<!--      /*-->
<!--        Below media-queries is fix for responsiveness of action buttons-->
<!--        Note: If you change action buttons or layout of this page, Please remove below style-->
<!--      */-->
<!--      @media (max-width: 689px) {-->
<!--        .vs-table&#45;&#45;search {-->
<!--          margin-left: 0;-->
<!--          max-width: unset;-->
<!--          width: 100%;-->

<!--          .vs-table&#45;&#45;search-input {-->
<!--            width: 100%;-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      @media (max-width: 461px) {-->
<!--        .items-per-page-handler {-->
<!--          display: none;-->
<!--        }-->
<!--      }-->

<!--      @media (max-width: 341px) {-->
<!--        .data-list-btn-container {-->
<!--          width: 100%;-->

<!--          .dd-actions,-->
<!--          .btn-add-new {-->
<!--            width: 100%;-->
<!--            margin-right: 0 !important;-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      .product-name {-->
<!--        max-width: 23rem;-->
<!--      }-->

<!--      .vs-table&#45;&#45;header {-->
<!--        display: flex;-->
<!--        flex-wrap: wrap;-->
<!--        margin-left: 1.5rem;-->
<!--        margin-right: 1.5rem;-->
<!--        > span {-->
<!--          display: flex;-->
<!--          flex-grow: 1;-->
<!--        }-->

<!--        .vs-table&#45;&#45;search{-->
<!--          padding-top: 0;-->

<!--          .vs-table&#45;&#45;search-input {-->
<!--            padding: 0.9rem 2.5rem;-->
<!--            font-size: 1rem;-->

<!--            &+i {-->
<!--              left: 1rem;-->
<!--            }-->

<!--            &:focus+i {-->
<!--              left: 1rem;-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      .vs-table {-->
<!--        border-collapse: separate;-->
<!--        border-spacing: 0 1.3rem;-->
<!--        padding: 0 1rem;-->

<!--        tr{-->
<!--          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);-->
<!--          td{-->
<!--            padding: 20px;-->
<!--            &:first-child{-->
<!--              border-top-left-radius: .5rem;-->
<!--              border-bottom-left-radius: .5rem;-->
<!--            }-->
<!--            &:last-child{-->
<!--              border-top-right-radius: .5rem;-->
<!--              border-bottom-right-radius: .5rem;-->
<!--            }-->
<!--          }-->
<!--          td.td-check{-->
<!--            padding: 20px !important;-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      .vs-table&#45;&#45;thead{-->
<!--        th {-->
<!--          padding-top: 0;-->
<!--          padding-bottom: 0;-->

<!--          .vs-table-text{-->
<!--            text-transform: uppercase;-->
<!--            font-weight: 600;-->
<!--          }-->
<!--        }-->
<!--        th.td-check{-->
<!--          padding: 0 15px !important;-->
<!--        }-->
<!--        tr{-->
<!--          background: none;-->
<!--          box-shadow: none;-->
<!--        }-->
<!--      }-->

<!--      .vs-table&#45;&#45;pagination {-->
<!--        justify-content: center;-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--</style>-->
